import React from 'react';
import '../styles/components/profile-page.scss';
import { Component } from '@poa/core';
import MenuPageTabs from '../components/menu/menu-tabs/menu-page-tabs';


class MenuPage extends React.Component {
  store; // injected by Poa

  render() {
    return (
      <MenuPageTabs accessLevel={this.store.auth.accessLevel} />
    );
  }
}

export default Component({ namespaces: ['menu'] })(MenuPage);
